import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import ServiceStatusSettings from './ServiceStatusSettings';

const ServiceStatus = React.lazy(() => import('./ServiceStatus'));

export default function ServiceStatusCard() {
  return (
    <Card raised>
      <CardHeader
        title="Service Status"
        titleTypographyProps={{ color: 'error', fontSize: 20 }}
        action={<ServiceStatusSettings />}
      />
      <CardContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          pt: 0,
          '&:last-child': { pb: 1.5 },
        }}
      >
        <React.Suspense fallback={<CircularProgress />}>
          <ServiceStatus />
        </React.Suspense>
      </CardContent>
    </Card>
  );
}
